import { nextTick } from "vue";
import { createRouter, createWebHistory } from "vue-router";
const aliases: Record<string, string> = {
  "minex-anfo": "novex-anfo",
  "nova-tronic": "novex-tronic",
  "novadet": "novex-det",
  "nove-x-det": "novex-det",
};
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  async scrollBehavior(to, _from, savedPosition) {
    await nextTick();
    if (savedPosition) return savedPosition;
    if (to.hash)
      return {
        el: to.hash,
        top: (document.querySelector(".header")?.getBoundingClientRect().height ?? 92) + 24,
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "instant"
          : "smooth",
      };
    return { top: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/HomeView.vue"),
    },
    {
      path: "/contact",
      name: "contact",
      component: () => import("@/views/ContactView.vue"),
      meta: { title: "Contact" },
    },
    { path: "/products", redirect: "/#products" },
    {
      path: "/products/:slug",
      redirect: (to) => {
        const slug = String(to.params.slug);
        return `/#${aliases[slug] ?? (["minex-prime", "novex-anfo", "novex-det", "novex-tronic"].includes(slug) ? slug : "products")}`;
      },
    },
    { path: "/equipment-technology", redirect: "/#technology" },
    { path: "/drilling-blasting", redirect: "/#services" },
    {
      path: "/services",
      redirect: (to) => (to.hash === "#products" ? "/#products" : "/#services"),
    },
    { path: "/portfolio", redirect: "/#portfolio" },
    { path: "/about", redirect: "/#people-technology" },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});
router.afterEach(async (to, from) => {
  await nextTick();
  if (to.path !== from.path && !to.hash)
    document
      .querySelector<HTMLElement>("main h1")
      ?.focus({ preventScroll: true });
});
export default router;
